<template>
  <div class="poster">
    <Row>
      <Col :xs="24"
           :sm="24">
      <Form :model="formItem"
            ref="formItem"
            :inline="true"
            action="javascript:void(0)">
        <FormItem>
          <Button @click="showModel()"
                  type="success"
                  class="f-r">添加</Button>
        </FormItem>
      </Form>
      </Col>
    </Row>
    <Table border
           :columns="columns1"
           ref="selection"
           :data="tablelist"
           :loading="dataloading"></Table>
    <div style="margin: 10px;overflow: hidden">
      <div style="float: right;">
        <Page ref="listPage"
              :total="pages.total"
              :current="pages.page"
              :page-size="pages.size"
              show-elevator
              show-total
              @on-change="changePage()"></Page>
      </div>
    </div>
    <!-- 添加的弹出 -->
    <Modal v-model="showModalStatus"
           title="添加"
           @on-ok="createAttr('attrValidate')"
           :loading="loading">
      <Form :model="attr"
            ref="attrValidate"
            :rules="attrValidate"
            action="javascript:void(0)">
        <FormItem label="名称"
                  prop="title">
          <Input v-model="attr.title"
                 placeholder="输入名称..."></Input>
        </FormItem>
        <FormItem label="封面图">
          <upload-thumb v-model="attr.thumb"
                        ref="uploadthumb"
                        :defaultList="thumblist"
                        :autoCropWidth="423.64"
                        :autoCropHeight="650"
                        :defaultTip="'图片格式:jpg、jpeg、png、gif,建议图片尺寸:670*1028,大小不超过2M'"></upload-thumb>
        </FormItem>
        <FormItem label="跳转类型">
          <Select v-model="
                  attr.link_type"
                  :style="{'width':'240px'}">
            <Option :value="0"
                    :key="0">H5</Option>
            <Option :value="1"
                    :key="1">商城小程序</Option>
            <Option :value="2"
                    :key="2">定制小程序</Option>
            <Option :value="3"
                    :key="3">盲盒小程序</Option>
            <Option :value="4"
                    :key="4">兑换商城</Option>
            <Option :value="5"
                    :key="5">非遗地图小程序</Option>
          </Select>
        </FormItem>
        <FormItem label="跳转内容">
          <Select v-model="
                  attr.link_content"
                  :style="{'width':'240px'}"
                  @on-change="LinkChange">
            <Option :value="0"
                    :key="0">普通</Option>
            <Option :value="1"
                    :key="1">商品</Option>
            <Option :value="2"
                    :key="2">匠人</Option>
          </Select>
        </FormItem>
        <FormItem label="跳转链接">
          <Input v-model="attr.url"
                 placeholder="输入链接..."></Input>
        </FormItem>
        <FormItem label="时间"
                  prop="date">
          <Input v-model="attr.date"
                 placeholder="例如：2020-07-08" />
        </FormItem>
      </Form>
    </Modal>
    <!--&lt;!&ndash; 修改的弹出 &ndash;&gt;-->
    <!--<Modal v-model="showEditInfoStatus" title="修改分类" @on-ok="updateAttr('attrValidate')" :loading="loading">-->
    <!--<Form :model="attr" ref="attrValidate" :rules="attrValidate" action="javascript:void(0)">-->
    <!--<FormItem label="名称" prop="title">-->
    <!--<Input v-model="attr.title" placeholder="输入名称..."></Input>-->
    <!--</FormItem>-->
    <!--<FormItem label="封面图">-->
    <!--<upload-thumb v-model="attr.thumb" ref="uploadthumb" :defaultList="thumblist"-->
    <!--:defaultTip="'图片格式:jpg、jpeg、png、gif,建议图片尺寸:670*1028,大小不超过2M'"></upload-thumb>-->
    <!--</FormItem>-->
    <!--<FormItem label="跳转链接">-->
    <!--<Input v-model="attr.url" placeholder="输入链接..."></Input>-->
    <!--</FormItem>-->
    <!--<FormItem label="时间">-->
    <!--<Input v-model="attr.date" placeholder="例如：2020-07-08"/>-->
    <!--</FormItem>-->
    <!--</Form>-->
    <!--</Modal>-->
  </div>
</template>

<script>
import UploadThumb from "../common/thumb";

export default {
  name: "poster",
  data () {
    return {
      loading: true,
      dataloading: true,
      thumblist: [],
      formItem: {},
      pages: {
        current: 1,
        total: 0,
        size: 20
      },
      columns1: [
        {
          title: "Id",
          key: "id",
          minWidth: 100,
          fixed: "left"
        },
        {
          title: "名称",
          key: "title",
          width: 100,
        },
        {
          title: "时间",
          width: 200,
          key: "date"
        },
        {
          title: '缩略图',
          key: 'thumb',
          width: 100,
          render: (h, params) => {
            let thumbImg = this.$publicData.ossUrl + params.row.thumb;
            return h('div', [
              h('Avatar', {
                props: {
                  src: thumbImg,
                  shape: "square",
                },

              }, '')
            ]);
          }
        },
        {
          title: "跳转地址",
          width: 200,
          key: "url"
        },
        {
          title: '状态',
          key: 'status',
          width: 150,
          render: (h, params) => {
            return h('div', [
              h('i-switch', {
                props: {
                  value: params.row.status == 1 ? true : false  //控制开关的打开或关闭状态，官网文档属性是value
                },
                on: {
                  'on-change': (value) => {
                    this.changeStatus(params.row.id, value)
                  }
                }
              }, '开关')
            ]);
          }
        },
        {
          title: "操作",
          key: "action",
          width: 200,
          align: "left",
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  props: {
                    type: "info",
                    size: "small"
                  },
                  style: {
                    marginRight: "5px"
                  },
                  on: {
                    click: () => {
                      this.showEditInfo(params.row.id);
                    }
                  }
                },
                "修改"
              ),
              h(
                "Button",
                {
                  props: {
                    type: "error",
                    size: "small"
                  },
                  on: {
                    click: () => {
                      this.remove(params.row.id);
                    }
                  }
                },
                "删除"
              )
            ]);
          }
        }
      ],
      tablelist: [],
      attr: {
        title: "",
        thumb: "",
        url: "",
        date: "",
        link_type: 0,
        link_content: 0,
      },
      showModalStatus: false,
      attrValidate: {
        title: [
          { required: true, message: "名称必须填写", trigger: "blur" }
        ],
        date: [
          { required: true, message: "日期必须填写", trigger: "blur" }
        ],
      }
    };
  },
  components: {
    UploadThumb,
  },
  // 计算
  computed: {},
  // 监听
  watch: {},
  created: function () {
    // 取数据
    this.getTableList();
  },
  methods: {
    getTableList: function () {
      this.pages.current = 1
      this.renderTable()
      return;
    },
    // 展开添加
    showModel () {
      this.attr = {
        title: "",
        thumb: "",
        url: "",
        date: "",
        link_type: 0,
        link_content: 0,
      };
      this.thumblist = new Array();
      this.$refs["attrValidate"].resetFields();
      this.showModalStatus = !this.showModalStatus;
    },
    // 添加
    createAttr (name) {
      this.$refs[name].validate(valid => {
        if (valid) {

          if (this.$refs["uploadthumb"].uploadList.length > 0) {
            this.attr.thumb = this.$refs["uploadthumb"].uploadList[0].url;
          } else {
            this.attr.thumb = null;
          }
          if (this.attr.id > 0) {
            this.$api.poster.edit({
              id: this.attr.id,
              title: this.attr.title,
              url: this.attr.url,
              date: this.attr.date,
              thumb: this.attr.thumb,
              link_type: this.attr.link_type,
              link_content: this.attr.link_content,
            }).then(res => {
              if (res.code == 200) {
                this.$Message.success(res.msg);
                this.showEditInfoStatus = !this.showEditInfoStatus;
                this.renderTable(1);
              }
              this.loading = false;
              this.$nextTick(() => {
                this.loading = true;
              });
              this.showModalStatus = !this.showModalStatus;
            });
          } else {
            this.$api.poster
              .create({
                title: this.attr.title,
                url: this.attr.url,
                date: this.attr.date,
                thumb: this.attr.thumb,
                link_type: this.attr.link_type,
                link_content: this.attr.link_content,
              })
              .then(res => {
                if (res.code == 200) {
                  this.showModalStatus = !this.showModalStatus;
                  this.attr.title = "";
                  this.renderTable(1);
                }
              });
            this.loading = false;
            this.$nextTick(() => {
              this.loading = true;
            });

          }

        } else {
          this.$Message.error("请检查输入的信息是否正确！");
          this.loading = false;
          this.$nextTick(() => {
            this.loading = true;
          });
        }
      });
    },
    LinkChange: function (value) {
      if (this.attr.link_type == 1 && value == 1) {
        this.attr.url = "pages/goods/detail/index?goodsId=";
      } else if (this.attr.link_type == 1 && value == 2) {
        this.attr.url = "pages/artisan/detail/index?tradesmanId=";
      } else {
        this.attr.url = "";
      }
    },
    //展开修改
    showEditInfo: function (index) {
      this.attr = {
        title: "",
        thumb: "",
        url: "",
        link_type: 0,
        link_content: 0,
        date: "",
      };
      this.thumblist = new Array();
      this.$refs["attrValidate"].resetFields();
      this.showModalStatus = !this.showModalStatus;
      // 取信息
      this.$api.poster.detail({ id: index }).then(res => {
        if (res.code == 200) {
          this.attr = res.result;
          if (this.attr.thumb != null && this.attr.thumb != "") {
            this.thumblist.push({
              name: this.attr.thumb,
              url: this.attr.thumb,
              status: "finished"
            });
          }
          this.$Message.success(res.msg);
        }
        this.loading = false;
        this.$nextTick(() => {
          this.loading = true;
        });
      });
    },
    // 修改状态
    changeStatus: function (index, value) {
      this.$api.poster.status({ id: index, status: value }).then(res => {
        if (res.code == 200) {
          this.$Message.success(res.msg);
        }
      });
    },
    remove: function (index) {
      // 弹出确认框
      this.$Modal.confirm({
        title: "警告",
        content: "<p>此操作不可恢复，三思而后行...</p>",
        onOk: () => {
          this.$api.poster.remove({ id: index }).then(res => {
            if (res.code == 200) {
              this.$Message.success(res.msg);
              this.renderTable(1);
            }
          });
        }
      });
    },
    changePage () {
      this.pages.current = this.$refs["listPage"].currentPage;
      this.renderTable(1);
    },
    // 筛选
    renderTable: function (name) {
      var self = this;
      var ps = {
        page: this.pages.current,
        size: this.pages.size,
        // key: this.formItem.key,
        // cateid: this.formItem.cate_id
      };
      this.$api.poster.list(ps).then(res => {
        this.dataloading = false;
        if (res.code == 200) {
          this.tablelist = res.result.list;
          this.pages.total = res.result.total;
          this.$Message.success(res.msg);
        }
      });
      return;
    }
  }
}
</script>

<style scoped>
</style>